import { render } from "./OutsourcingServiceSection.vue?vue&type=template&id=2c26a6e0&scoped=true"
import script from "./OutsourcingServiceSection.vue?vue&type=script&lang=js"
export * from "./OutsourcingServiceSection.vue?vue&type=script&lang=js"

import "./OutsourcingServiceSection.vue?vue&type=style&index=0&id=2c26a6e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c26a6e0"],['__file',"OutsourcingServiceSection.vue"]])

export default __exports__